<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-04-19 18:48:59
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2021-07-12 19:29:26
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\DoctorSnurses\components\Case1HeaderSearch\index.vue
-->
<template>
    <header>
        <el-form inline size="mini" :model="seachFormData">
            <div style="margin-bottom:20px">客服消息管理</div>
            <el-form-item>
                <el-input 
                prefix-icon="el-icon-search"
                placeholder="请输入患者姓名" 
                v-model="seachFormData.redundant"
                style="width:300px">
                </el-input>
            </el-form-item>
            <el-form-item>
                <el-button @click="resetHandel">重置</el-button>
                <el-button type="primary" @click="inquireHeader" style="background:#1A7BFC">搜索</el-button>
            </el-form-item>
        </el-form>
    </header>
</template>
<script>
export default {
    name:'Case1HeaderSeract',
    data(){
        return{
            platformList:[],//归属平台列表
            seachFormData:{
                keyword:'',//模糊查询字段
            },
           
        }
    },
    mounted(){
        //TODO init为true来判断是否第一次加载
        this.$emit('inquire',{...this.seachFormData,init:true})
    },
    methods:{
        /**
         * @description: 重置通知
         * @param {*}
         * @return {*}
         */
        resetHandel(){
            this.seachFormData = this.$options.data().seachFormData;
            this.$emit('reset',this.seachFormData)
        },
        
        /**
         * @description: 查询通知
         * @param {*}
         * @return {*}
         */
        inquireHeader(){
            const param = this.seachFormData;
            // param.endTime = param.timeList[1];
            // param.beginTime = param.timeList[0];
            this.$emit('inquire',param)
        },
    }
}
</script>
<style scoped lang="less">
    header{
        background: #fff;
        .el-form{
            margin-bottom: 13px;
        }
         .el-form-item__content{
            & /deep/ .el-button:focus, .el-button:hover {
                // color: #1A7BFC !important;
                border-color: #1A7BFC !important;
                // background-color: #1A7BFC !important;
            }
        }
    }
</style>